import {useState, useEffect, useRef}        from "react";
import {useLoader}                          from "components/Covers/loadingCover";
import {useActionModal}                     from "components/Covers/confirmAction";
import {useInfoMsgModal}                    from "components/Covers/infoMessageModal";
import {useToastMessage}                    from "components/Covers/toastMessage";
import {InputGeneral}                       from "components/Field/field";
import {BtnCloseAction}                     from "components/Buttons/Close/BtnClose";
import MainStyle                            from "components/UI/main.module.scss";
// BEGIN AG AGRID
import {AgGridReact}                        from "ag-grid-react";
import {AllCommunityModule,ModuleRegistry}  from 'ag-grid-community';
import {AG_GRID_LOCALE_BR}                  from '@ag-grid-community/locale';
import {q3x_FunData, 
        DefaultLoadingLogo,
        DavidCopperfield,
        Heimdall,
        GetLabel,
        GetAppLang,
        SetLastFeature}                     from "Utilities/utils";

import {getCompanyPositionList,
        getCompanyPositionByID,
        updateCompanyPosition,
        deleteCompanyPosition}              from "./companyPositionService";

import {DisplayGridDatetime}                from "components/Date/date";
import { useNavigate }                      from "react-router-dom";

let blank_position_obj = {
    'COMPANY_POSITION_ID': 0,
    'COMPANY_POSITION_DESC': "",
    "USERS": ""
};

let appLang = null;

const CompanyPositionEditPanel = ({setProps, data}) => {
    const { showLoader, hideLoader }       = useLoader();                  // Control over the loader
    const { showInfoMessage }              = useInfoMsgModal();            // Modal message control 
    const { showActionMessage }            = useActionModal();             // Modal message + action control     
    const { showToastMessage }             = useToastMessage();            // Toast message display
    const [positionObj,   setPositionObj]  = useState(blank_position_obj); // Sector Object
    
    const handleExit = () => {
        setProps({ setScreen: 1, data: blank_position_obj });
    };

    const BtnExit = () => {
        showActionMessage(
          { header: GetLabel(appLang, 54), message: <>{GetLabel(appLang, 102)}<br/>{GetLabel(appLang, 103)}</> },
          { confirm_action: () => handleExit()}
        );
    };


    const handleSave = async () => {
        if (positionObj.COMPANY_POSITION_DESC == "") {
            let message = GetLabel(appLang, 121);
            showInfoMessage({'header': GetLabel(appLang, 54), 'message': message});
            return;            
        }
        showLoader({logoElement: DefaultLoadingLogo(), loadingMessage: GetLabel(appLang, 0)});
        let fetchedData = await updateCompanyPosition(positionObj);
        if (fetchedData) {
            if (fetchedData?.status?.statusCode == 0) {
                hideLoader();
                showToastMessage({'header': GetLabel(appLang, 14), 'message': GetLabel(appLang, 106)});
                if (positionObj.COMPANY_POSITION_ID === 0) {
                    setProps({ setScreen: 1, data: blank_position_obj });
                }
            }
            else {
                hideLoader();
                showInfoMessage({'header': GetLabel(appLang, 107), 'message': fetchedData.status.message});
            }
        }        
    };

    const handleDelete = async () => {
        showLoader({logoElement: DefaultLoadingLogo(), loadingMessage: GetLabel(appLang, 0)});
        let fetchedData = await deleteCompanyPosition(positionObj.COMPANY_POSITION_ID);
        if (fetchedData){
            if (fetchedData?.status?.statusCode == 0) {
                hideLoader();
                setProps({ setScreen: 1, data: blank_position_obj });
            }
            else {
                hideLoader();
                showInfoMessage({'header': GetLabel(appLang, 107), 'message': fetchedData.status.message});
            }
        }
    };

    const handleChange = (updatedValues) => {
        setPositionObj(prevState => ({
            ...prevState,
            ...updatedValues
        }));
    };

    const BtnSave = () => {
        showActionMessage(
          { header: GetLabel(appLang, 54), message: GetLabel(appLang, 122) },
          { confirm_action: () => handleSave()}
        );
    };

    const BtnDelete = () => {
        showActionMessage(
          { header: GetLabel(appLang, 54), message: GetLabel(appLang, 123) },
          { confirm_action: () => handleDelete()}
        );
    };

    useEffect(() => {
        const fetchData = async (company_position_id) => {
            try {
                showLoader({logoElement: DefaultLoadingLogo(), loadingMessage: GetLabel(appLang, 0) });
                let fetchedData = await getCompanyPositionByID(company_position_id);
                if (fetchedData) {
                    if (fetchedData?.status?.statusCode == 0) {
                        if (fetchedData?.response?.content) {
                            fetchedData = fetchedData.response.content;
                            setPositionObj(fetchedData || blank_position_obj);
                            hideLoader();
                        }
                    }
                    else {
                        hideLoader();
                        showInfoMessage({'header': GetLabel(appLang, 107) , 'message': fetchedData.status.message});
                    }                    
                }
            } 
            catch (error) {
                setPositionObj(blank_position_obj);
            }
        };
        if (data?.COMPANY_POSITION_ID && data.COMPANY_POSITION_ID !== 0) {
            fetchData(data.COMPANY_POSITION_ID);
        } 
        else {
            setPositionObj(blank_position_obj);
        }
    }, [data]);

    return(
        <>
            <div className={[MainStyle.bg_card, MainStyle.shadow, MainStyle.border, MainStyle.rounded].join(" ")}>
                <div className={MainStyle.mt_3}/>
                <div className={MainStyle.row}>
                    <div className={MainStyle.col_1}>                            
                    </div>
                    <div className={MainStyle.col_11}>
                        <div className={[MainStyle.text_end, MainStyle.mx_3].join(" ")}>
                            {<BtnCloseAction click_action={BtnExit}/>}
                        </div>
                    </div>
                </div>
                <div className={MainStyle.mt_3}/>


                <div className={[MainStyle.bg_card_inner,
                                 MainStyle.border_top,
                                 MainStyle.border_bottom,
                                 MainStyle.border_end].join(" ")}>
                    
                    <div className={MainStyle.mt_5}/>
                    <div className={MainStyle.row}>
                        <div className={MainStyle.col_lg_1}/>
                        <div className={MainStyle.col_lg_5}>
                            <div className={[MainStyle.text_start, MainStyle.ms_3].join(" ")}>
                                <span className={[MainStyle.fs_6,
                                                  MainStyle.text_body,
                                                  MainStyle.fw_semibold
                                                ].join(" ")}
                                >
                                    {GetLabel(appLang, 124)} *:
                                </span>
                            </div>
                        </div>
                        <div className={MainStyle.col_lg_5}>
                            <div className={MainStyle.mx_3}>
                                <InputGeneral 
                                                value={positionObj.COMPANY_POSITION_DESC}
                                                className={[MainStyle.fs_6, MainStyle.text_input, MainStyle.border_1].join(" ")} 
                                                onChange={(event) => handleChange({ COMPANY_POSITION_DESC: q3x_FunData(event.target.value) })}
                                                placeholder={GetLabel(appLang, 125)}
                                                maxLength={150}
                                />
                                <span className={[MainStyle.ms_2, MainStyle.text_body_faded, MainStyle.fs_8].join(" ")}>{positionObj.COMPANY_POSITION_DESC.length} {GetLabel(appLang, 44)} 150 {GetLabel(appLang, 45)}.</span>
                            </div>
                        </div>
                        <div className={MainStyle.col_lg_1}/>
                    </div>
                    {
                        positionObj.COMPANY_POSITION_ID != 0 ? 
                            <>
                            <div className={MainStyle.mt_3}></div>
                            <div className={MainStyle.row}>
                                <div className={MainStyle.col_lg_1}/>
                                <div className={MainStyle.col_lg_5}>
                                    <div className={[MainStyle.text_start, MainStyle.mx_3].join(" ")}>
                                        <span className={[MainStyle.fs_6,
                                                          MainStyle.text_body,
                                                          MainStyle.fw_semibold
                                                        ].join(" ")}
                                        >
                                            {GetLabel(appLang, 126)}:
                                        </span>
                                    </div>
                                </div>
                                <div className={MainStyle.col_lg_5}>
                                    <div className={[MainStyle.text_start, MainStyle.mx_3].join(" ")}>
                                        <span className={[MainStyle.fs_6,
                                                          MainStyle.text_body,
                                                          MainStyle.text_justify                                                   
                                                        ].join(" ")}
                                        >
                                            {positionObj.USERS}
                                        </span>
                                    </div>
                                </div>
                                <div className={MainStyle.col_lg_1}/>
                            </div>
                            </>
                        :
                            null
                    }
                    <div className={[MainStyle.py_3, MainStyle.mx_5].join(" ")}/>
                    
                </div>

                <div className={MainStyle.my_5}/>

            </div>
            {/*--------------------------------------------------------------------------*/}            
            <div className={MainStyle.row}>
                <div className={MainStyle.col_lg_7}></div>
                <div className={MainStyle.col_lg_2}>
                    {DavidCopperfield(15,89,6) && (
                        positionObj.COMPANY_POSITION_ID != 0 ? 
                            <div className={[MainStyle.mt_3].join(" ")}>
                                <button
                                    style={{width: '100%'}}
                                    className={[MainStyle.btn_delete, 
                                                MainStyle.rounded_3, 
                                                MainStyle.border, 
                                                MainStyle.shadow_sm, 
                                                MainStyle.fs_6,
                                                MainStyle.py_3,
                                                MainStyle.px_5].join(" ")}
                                    onClick={BtnDelete}
                                >
                                    {GetLabel(appLang, 114)}
                                </button>
                            </div>
                    : 
                        null
                    )}
                </div>
                <div className={MainStyle.col_lg_1}></div>
                <div className={MainStyle.col_lg_2}>
                    {DavidCopperfield(15,89,4) &&  (
                        <div className={[MainStyle.mt_3].join(" ")}>
                            <button
                                style={{width: '100%'}}
                                className={[MainStyle.btn_green, 
                                            MainStyle.rounded_3, 
                                            MainStyle.border, 
                                            MainStyle.shadow_sm, 
                                            MainStyle.fs_6,
                                            MainStyle.text_white,
                                            MainStyle.py_3,
                                            MainStyle.px_5].join(" ")}
                                onClick={BtnSave}
                            >
                                {GetLabel(appLang, 49)}
                            </button>
                        </div>
                    )}
                </div>
            </div>
            {/*--------------------------------------------------------------------------*/}
        </>
    );

};

const CompanyPositionTableGrid = ({setProps}) => {
    const [ isLoading,  setIsLoading]            = useState(false);   // Loading fetch control
    const { showLoader, hideLoader }             = useLoader();       // Control over the  
    const [searchText,  setSearchText]           = useState('');      // Searched text state
    const [rowData,     setRowData]              = useState([]);      // State of rows def 
    const [columnDefs,  setcolumnDefs]           = useState([]);      // State of columns def
    const gridRef                                = useRef();
    const { showInfoMessage }                    = useInfoMsgModal(); // Modal message control 

    ModuleRegistry.registerModules([AllCommunityModule]);

    const gridOptions = {
        pagination: true, // Enable pagination
        paginationPageSize: 20, // Number of rows per page
        localeText: GetAppLang() === "PT" ? AG_GRID_LOCALE_BR : null,
        suppressHorizontalScroll: false,
        embedFullWidthRows: true,
        groupSuppressBlankHeader: false,
        enableCellTextSelection: true
    };

    const EditItem = (props) => {
        const handleData = () => {
            let obj_copy = JSON.parse(JSON.stringify(blank_position_obj));
            obj_copy.COMPANY_POSITION_ID = props.data.COMPANY_POSITION_ID;
            setProps({ setScreen: 2, data: obj_copy });
        };
        return(
            <>
                <div 
                    onClick={() => {handleData()}} 
                    className={[MainStyle.table_btn_icon, MainStyle.shadow_sm, MainStyle.p_1, MainStyle.text_center].join(" ")}>
                    <svg 
                        xmlns="http://www.w3.org/2000/svg" 
                        viewBox="0 0 512 512"
                        className={[MainStyle.small_ico_generic].join(" ")}
                    >
                        <path d="M471.6 21.7c-21.9-21.9-57.3-21.9-79.2 0L362.3 51.7l97.9 97.9 30.1-30.1c21.9-21.9 21.9-57.3 0-79.2L471.6 21.7zm-299.2 220c-6.1 6.1-10.8 13.6-13.5 21.9l-29.6 88.8c-2.9 8.6-.6 18.1 5.8 24.6s15.9 8.7 24.6 5.8l88.8-29.6c8.2-2.7 15.7-7.4 21.9-13.5L437.7 172.3 339.7 74.3 172.4 241.7zM96 64C43 64 0 107 0 160L0 416c0 53 43 96 96 96l256 0c53 0 96-43 96-96l0-96c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 96c0 17.7-14.3 32-32 32L96 448c-17.7 0-32-14.3-32-32l0-256c0-17.7 14.3-32 32-32l96 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L96 64z"/>
                    </svg>
                </div>
            </>
        );
    };

    const defaultCol = [
        DavidCopperfield(15,89,4) && {
          headerName: GetLabel(appLang, 115),
          field: 'editar',
          cellRenderer: EditItem,
          cellClass: [MainStyle.table_text_center].join(" "), 
          headerClass: MainStyle.table_header_center,
          flex: 0,
        },
        { headerName: GetLabel(appLang, 34),   field: "COMPANY_POSITION_ID"    ,filter: true , flex: 0, headerClass: MainStyle.table_header_center, cellClass: [MainStyle.table_text_center].join(" "),}    ,    
        { headerName: GetLabel(appLang, 127),  field: "COMPANY_POSITION_DESC"  ,filter: true , flex: 1,}    ,
        { headerName: GetLabel(appLang, 118),  field: "UPDATED"                ,filter: true , cellRenderer: DisplayGridDatetime, flex: 0,}    ,
    ].filter(Boolean);

    const onQuickFilterChanged = (e) => {
        setSearchText(e.target.value);
    };

    useEffect(() => {
        const fetchData = async () => {
            if (!isLoading) {
                setIsLoading(true);
                showLoader({logoElement: DefaultLoadingLogo(), loadingMessage: GetLabel(appLang, 0)});
                let data = await getCompanyPositionList();
                if (data) {
                    if (data?.status?.statusCode == 0) {
                        if (data?.response?.content) {
                            data = data.response.content;
                            setcolumnDefs(defaultCol);
                            let arr = [];
                            for(var j = 0; j < data.length; j++) {
                                arr.push(data[j]);
                            }
                            setRowData(arr);
                            hideLoader();
                            setIsLoading(false);
                        }
                    }
                    else {
                        hideLoader();
                        showInfoMessage({'header': GetLabel(appLang, 107), 'message': data.status.message});
                    }
                }
            }
        };
        fetchData();
    },[]);

    return (
        <>
        <div className={[MainStyle.bg_card, MainStyle.shadow, MainStyle.border, MainStyle.rounded].join(" ")}>
            <div className={[MainStyle.px_2, MainStyle.mt_3].join(" ")}>
                <div className={MainStyle.row}>
                    <div className={MainStyle.col_lg_9}></div>
                    <div className={MainStyle.col_lg_3}>
                        <div className={[MainStyle.d_flex].join(" ")}>
                            <div className={[MainStyle.mt_2, MainStyle.me_2].join(" ")}>
                                <svg 
                                    xmlns="http://www.w3.org/2000/svg" 
                                    viewBox="0 0 512 512"
                                    className={MainStyle.small_ico_search_bar}
                                >
                                    <path d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z"/>
                                </svg>
                            </div>
                            <InputGeneral 
                                value={searchText}
                                className={[MainStyle.fs_6, MainStyle.text_input, MainStyle.border_1, MainStyle.mb_3].join(" ")} 
                                onChange={onQuickFilterChanged}
                                placeholder={GetLabel(appLang, 33)}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div style={{ height: '40rem'}}>
                <AgGridReact 
                    ref={gridRef}
                    rowData={rowData}
                    columnDefs={columnDefs}
                    gridOptions={gridOptions}
                    quickFilterText={searchText}
                />
            </div>
        </div>
    </>);
};

export const CompanyPositionPage = () => {
    const [ screenType, setScreenType ]       = useState(1);
    const [ defaultData, setDefaultData]      = useState({});
    const navigate                            = useNavigate();

    const BtnNew = () => {
        handleChange({ setScreen: 2,
                       data: blank_position_obj });
    };

    const handleChange = ({ setScreen, data }) => {
        setDefaultData({ ...data });
        setScreenType(setScreen);
    };

    useEffect(() => {
        if (!Heimdall([15])) {
            navigate('/home');
        }
        else {
            SetLastFeature(15);
        }
    }, [screenType, defaultData]);

    return (
        <>
        {
        screenType == 1? 
        <>
            <div>
                <p className={[MainStyle.fs_4, MainStyle.mx_3, MainStyle.text_body, MainStyle.fw_semibold].join(" ")}>
                    {GetLabel(appLang, 128)}
                </p>
            </div>
            <div className={MainStyle.row}>
                <div className={MainStyle.col_lg_10}/>
                <div className={MainStyle.col_lg_2}>
                    {DavidCopperfield(15,89,0) && (
                        <div className={[MainStyle.mx_3].join(" ")}>
                            <button
                                style={{width: '100%'}}
                                className={[MainStyle.btn_blue, 
                                            MainStyle.rounded_3, 
                                            MainStyle.border, 
                                            MainStyle.shadow_sm, 
                                            MainStyle.fs_6,
                                            MainStyle.text_white,
                                            MainStyle.py_3,
                                            MainStyle.px_5].join(" ")}
                                onClick={BtnNew}
                            >
                                {GetLabel(appLang, 120)}
                            </button>
                        </div>
                    )}
                </div>
            </div>            
            <div className={MainStyle.row}>
                <div className={MainStyle.col_12}>
                    <div className={[MainStyle.mx_3, MainStyle.my_3].join(" ")}>
                        <CompanyPositionTableGrid setProps={handleChange}/>
                    </div>
                </div>
            </div>
            <div className={MainStyle.pb_3}></div>
        </>
        : 
        <>
            <div>
                <p className={[MainStyle.fs_4, MainStyle.mx_3, MainStyle.text_body, MainStyle.fw_semibold].join(" ")}>
                    {GetLabel(appLang, 128)}
                </p>
            </div>
            <div className={[MainStyle.mx_3, MainStyle.my_3].join(" ")}>
                <CompanyPositionEditPanel setProps={handleChange} data={defaultData} />
            </div>
        </>
        }
        </>
    );
};